
const messages = {
    en: {
       delivery: {
          coupon: {
            name: 'Coupon',
            title: 'Coupon management',
            subtitle: 'View, search, create, edit and delete Coupon',
            creating: 'Creating Coupon',
            editing: 'Editing Coupon',
            deleting: 'Deleting Coupon',
            showing: 'Showing Coupon',
            menu: 'Coupon',
            labels: {
                code: 'Code',
                description: 'Description',
                discountType: 'Discount Type',
                discountValue: 'Discount Value',
                minimumOrderAmount: 'Minimum Order Amount',
                startDate: 'Start Date',
                expirationDate: 'Expiration Date',
                maxTotalUses: 'Max Total Uses',
                active: 'Active'
            },

          }
       }
    },
    es: {
       delivery: {
          coupon: {
            name: 'Cupon',
            title: 'Administración de Cupones',
            subtitle: 'Ver, buscar, crear, editar, y borrar Cupon',
            creating: 'Creando Cupón',
            editing: 'Modificando Cupón',
            deleting: 'Eliminando Cupón',
            showing: 'Detalles de Cupón',
            menu: 'Cupones',
            labels: {
                code: 'Código',
                description: 'Descripción',
                discountType: 'Tipo de Descuento',
                discountValue: 'Valor Descuento',
                minimumOrderAmount: 'Monto Minimo Pedido',
                startDate: 'Fecha Incio',
                expirationDate: 'Fecha Expiración',
                maxTotalUses: 'Máximo Total de Usos',
                active: 'Activo'
            },

          }
       }
    },
    pt: {
       delivery: {
          coupon: {
            name: 'Coupon',
            title: 'Administração de Coupon',
            subtitle: 'Ver, buscar, criar, editar e usar Coupon',
            creating: 'Criando Coupon',
            editing: 'Edição Coupon',
            deleting: 'Apagando Coupon',
            showing: 'Detalhes do Coupon',
            menu: 'Coupon',
            labels: {
                code: 'Código',
                description: 'Descripción',
                discountType: 'Tipo de Descuento',
                discountValue: 'Valor Descuento',
                minimumOrderAmount: 'Monto Minimo Pedido',
                startDate: 'Fecha Incio',
                expirationDate: 'Fecha Expiración',
                maxTotalUses: 'Maximo Total de Usos',
                active: 'Activo'
            },

          }
       }
    }
}

export default messages
